import Header from "./components/Home/Header/Header";
import Ecosystem from "./components/Home/Ecosystem/Ecosystem";
import Platform from "./components/Home/Platform/Platform";
import Network from "./components/Home/Network/Network";
import Banking from "./components/Home/Banking/Banking";
import Timeline from "./components/Home/Timeline/Timeline";
import Ankerplatform from "./components/Home/Ankerplatform/Ankerplatform";
import Partners from "./components/Home/Partners/Partners";
import Video from "./components/Home/Video/Video";
import React from "react";

function App() {
  return (
    <React.Fragment>
      <Header />
      <Ecosystem />
      <Platform />
      <Network />
      <Banking />
      <Timeline />
      <Ankerplatform />
      <Partners title={"Partners"} />
      <Video />
    </React.Fragment>
  );
}

export default App;
